<template>
  <div>
    <auth-layout
      :isLoading="isLoading"
      :isFluid="true"
      contentClass="pt-0"
      pageClass="login-page"
      styleContent="min-height: auto"
    >
      <div class="login-split-layout">
        <div class="login-left-panel">
          <div class="login-left-content">
            <div class="login-logo-wrapper">
              <img
                src="/static/img/logo-smartcultivo-blanco.png"
                alt="Logo SmartCultivo"
                class="login-brand-logo"
              />
            </div>
            <form method="POST" class="form-login">
              <fade-render-transition>
                <card class="card-login">
                  <div>
                    <fg-input
                      :label="$t('common_words.user')"
                      v-validate="modelValidations.user"
                      v-on:keyup="validate"
                      :error="getError('common_words.user', true)"
                      name="common_words.user"
                      placeholder=""
                      type="text"
                      v-model="model.login"
                    >
                    </fg-input>
                    <label>{{ $t('common_words.password') }}</label>
                    <fg-input
                      v-validate="modelValidations.password"
                      v-on:keyup="validate"
                      :error="getError('common_words.password', true)"
                      name="common_words.password"
                      :type="inputTypePass"
                      :myCustom="{ addon: 'not-input-group-addon' }"
                      placeholder=""
                      v-model="model.password"
                      class="mb-4"
                    >
                      <template slot="addonRight">
                        <l-button @click="showPassword" class="btn-round">
                          <em :class="iconBtnPass"></em>
                        </l-button>
                      </template>
                    </fg-input>
                    <div
                      class="d-flex justify-content-between align-items-center mb-3"
                    >
                      <l-checkbox
                        v-model="model.remember_me"
                        class="remember-text custom-remember_me mb-0"
                      >
                        {{ $t('vie.Pag.Aut.Login.remindMe') }}
                      </l-checkbox>
                      <button
                        id="btnLogin"
                        type="submit"
                        class="btn btn-fill btn-info btn-round mb-0"
                        @click.prevent="validateSubmit"
                        :disabled="enabledBtn"
                      >
                        {{ $t('vie.Pag.Aut.Login.access') }}
                      </button>
                    </div>
                    <div class="row mt-4 text-center">
                      <div class="col">
                        <l-button
                          style="width: 100%"
                          type="social"
                          v-on:click="isLoading = true"
                          class="btn-google"
                          size="md"
                          @click.prevent="AuthProvider('google')"
                        >
                          <em class="fa fa-google"></em>
                          &nbsp;{{ $t('vie.Pag.Aut.Login.enterWithGoogle') }}
                        </l-button>
                      </div>
                    </div>
                    <div class="row mt-1 text-center">
                      <div class="col">
                        <l-button
                          style="width: 100%"
                          type="social"
                          v-on:click="isLoading = true"
                          class="btn-microsoft"
                          size="md"
                          @click.prevent="loginMicrosoft"
                        >
                          <img
                            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                            alt="Microsoft"
                            style="width: 22px; height: 22px"
                          />

                          &nbsp;&nbsp;{{
                            $t('vie.Pag.Aut.Login.enterWithMicrosoft')
                          }}
                        </l-button>
                      </div>
                    </div>
                    <br />
                    <div class="forgot text-center">
                      <a
                        @click="showSwalPasswordRequest"
                        class="card-category pointer"
                      >
                        {{ $t('vie.Pag.Aut.Login.forgotYourPassword') }}
                      </a>
                    </div>
                    <div class="text-center d-flex justify-content-end mt-3">
                      <menu-translate
                        m="mr-0"
                        :isSelect="true"
                        :showAbbreviation="false"
                      />
                    </div>
                  </div>
                </card>
              </fade-render-transition>
            </form>

            <a
              href="https://smartcultivo.com"
              target="_blank"
              class="login-footer-url"
              rel="noopener"
              >www.smartcultivo.com</a
            >
          </div>
        </div>

        <div class="login-right-panel">
          <div class="login-right-header">
            <a
              v-for="social in socialLinks"
              :key="social.name"
              :href="social.url"
              class="social-icon-link"
              target="_blank"
              rel="noopener"
            >
              <em :class="social.icon"></em>
            </a>
          </div>
          <div class="login-slider-section">
            <div class="login-slider-frame">
              <transition name="slider-fade" mode="out-in">
                <img
                  v-if="currentSlideImage.src"
                  :key="currentSlideImage.src || currentSlide"
                  :src="currentSlideImage.src"
                  :alt="currentSlideImage.alt"
                  class="login-slider-image"
                />
                <div
                  v-else
                  :key="'placeholder-' + currentSlide"
                  class="login-slider-placeholder"
                >
                  <code>sliderImages</code>
                </div>
              </transition>
            </div>
            <div class="login-slider-dots">
              <button
                v-for="(slide, index) in sliderImages"
                :key="slide.alt + index"
                type="button"
                class="login-slider-dot"
                :class="{ active: currentSlide === index }"
                @click="goToSlide(index)"
              ></button>
            </div>
          </div>
          <div class="login-right-footer">
            Un producto de <strong>Aplicaciones Corporativas Ⓡ</strong>
          </div>
        </div>
      </div>
      <app-politics
        v-model="showPolitics"
        :policy="policy"
        @confirm="confirm"
      />
    </auth-layout>
  </div>
</template>
<script>
import { AXIOS_URL, DISK_URL, setLocalizeLanguage } from 'src/util/Util';
import {
  Checkbox as LCheckbox,
  FadeRenderTransition,
} from 'src/components/index';
import { mapActions } from 'vuex';
import AppPolitics from './AppPolitics.vue';
import AuthLayout from 'src/views/Layouts/AuthLayout.vue';
import axios from 'axios';
import i18n from 'src/i18n';
import MenuTranslate from 'src/views/Layouts/MenuTranslate.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinPolitics from 'src/mixins/mixin-politics';
import SweetAlert from 'src/class/Alerts';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import VueSocialauth from 'vue-social-auth';

//Languajes
Vue.use(VeeValidate);
setLocalizeLanguage();

// Definimos la configuracion basica de vue-social-auth
Vue.use(VueAxios, axios);
Vue.use(VueSocialauth, {
  baseUrl: AXIOS_URL, // Your API domain
  providers: {
    google: {
      clientId:
        '48643883768-u6tdu311t5m61r77effqu4o7hub86qr1.apps.googleusercontent.com',
      //redirectUri: AXIOS_URL + '/auth/google/callback' // Your client app URL
      redirectUri: AXIOS_URL + '/auth/google/callback', // Your client app URL
    },
  },
});

export default {
  name: 'signin',
  components: {
    LCheckbox,
    FadeRenderTransition,
    AuthLayout,
    AppPolitics,
    MenuTranslate,
  },
  data() {
    return {
      enabledBtn: false,
      model: {
        login: '',
        password: '',
        remember_me: false,
      },
      modelValidations: {
        user: {
          required: true,
        },
        password: {
          required: true,
          min: 8,
        },
      },
      inputTypePass: 'password',
      iconBtnPass: 'fa fa-eye',
      currentSlide: 0,
      sliderInterval: null,
      sliderImages: [
        {
          src: '/static/img/slide1.png',
          alt: 'Slide 1',
        },
        {
          src: '/static/img/slide2.png',
          alt: 'Slide 2',
        },
        {
          src: '/static/img/slide3.png',
          alt: 'Slide 3',
        },
      ],
      socialLinks: [
        {
          name: 'youtube',
          icon: 'fa fa-youtube-play',
          url: 'https://www.youtube.com/@smartcultivo',
        },
        {
          name: 'facebook',
          icon: 'fa fa-facebook',
          url: 'https://www.facebook.com/profile.php?id=100064196884688',
        },
        {
          name: 'instagram',
          icon: 'fa fa-instagram',
          url: 'https://www.instagram.com/smartcultivo/',
        },
        {
          name: 'linkedin',
          icon: 'fa fa-linkedin',
          url: 'https://www.linkedin.com/company/97036674/admin/page-posts/published/',
        },
        {
          name: 'x',
          icon: 'fa fa-times',
          url: 'https://x.com/CultivoSmart',
        },
      ],
    };
  },
  computed: {
    currentSlideImage() {
      return (
        this.sliderImages[this.currentSlide] || {
          src: '',
          alt: 'Slide',
        }
      );
    },
  },
  watch: {
    showPolitics(newVal) {
      if (!newVal) {
        this.logout();
      } else {
        setTimeout(() => {
          document.getElementsByClassName('v-modal')[0].remove();
        }, 300);
      }
    },
  },

  mixins: [MixinForm, mixinPolitics],
  methods: {
    /**
     *  mapeamos las acciones de nuestro store para poder llamarlas desde este script
     */
    ...mapActions({
      login: 'auth/login',
      logout: 'auth/logout',
      closeAllUserSessions: 'auth/closeAllUserSessions',
      loginGoogle: 'auth/loginGoogle',
      passwordRequest: 'auth/passwordRequest',
    }),
    getDISK_URL() {
      return DISK_URL;
    },

    // Redirige al backend para iniciar OAuth
    loginMicrosoft() {
      window.location.href = this.getDISK_URL() + 'auth/microsoft';
    },

    /* este metodo se encagar de llamar nuestra accion login del store*/
    signin() {
      this.isLoading = true;
      // llamamos a la accion enviando los datos del formulario por parametro
      this.login(this.model)
        .then((response) => {
          // en caso de respuesta, redireccionamos al usuario
          if (response.data && response.data.code) {
            this.auth(response);
          } else {
            this.validatePolitics();
          }
        })
        .catch((error) => {
          if (error.response.data.code && error.response.data.code == 4) {
            SweetAlert.default(
              i18n.t('vie.Pag.Aut.Login.activeSession'),
              `<p> ${error.response.data.message} </p>`,
              i18n.t('vie.Pag.Aut.Login.closeActiveSessions')
            ).then((result) => {
              // si el usuario acepta llamamos a la ruta de cambio con el token
              if (result.value) {
                this.isLoading = true;
                this.closeAllUserSessions(this.model).then((response) => {
                  this.isLoading = false;
                  SweetAlert.success(response.data.message).then((result) => {
                    this.isLoading = true;
                    this.login(this.model).then((response) => {
                      this.validatePolitics();
                    });
                  });
                });
              }
            });
          } else {
            // en caso de error mostramos una alerta
            const msg = error.response.message
              ? error.response.message
              : error.response.data.message;

            if (error.response.data.code && error.response.data.code === 474) {
              SweetAlert.warning(msg);
            } else {
              SweetAlert.danger(msg);
            }
          }

          this.isLoading = false;
        });
    },

    // este metodo se encarga de llamar a nuestro proveedor de login
    AuthProvider(provider) {
      var self = this;
      // llamamos al metodo authenticate de la libreria con el proveedor
      this.$auth
        .authenticate(provider)
        .then((response) => {
          self.SocialLogin(provider, response);
        })
        .catch((err) => {
          SweetAlert.danger(i18n.t('vie.Pag.Aut.Login.errorText1') + err);
          this.isLoading = false;
        });
    },

    // realizamos una peticion a la api con los datos del proveedor
    SocialLogin(provider, response) {
      this.$http
        .post('/auth/sociallogin/' + provider, response)
        .then((response) => {
          // si el usuario existe, obtenemos el token y hacemos el login
          this.loginGoogle(response.data.data.access_token)
            .then(() => {
              if (response.data && response.data.code) {
                this.auth(response);
              } else {
                this.validatePolitics();
              }
            })
            .catch(() => {
              this.isLoading = false;
            });
        })
        .catch((error) => {
          if (error.response.data.code && error.response.data.code == 4) {
            SweetAlert.default(
              i18n.t('vie.Pag.Aut.Login.activeSession'),
              `<p> ${error.response.data.message} </p>`,
              i18n.t('vie.Pag.Aut.Login.closeActiveSessions')
            ).then((result) => {
              // si el usuario acepta llamamos a la ruta de cambio con el token
              if (result.value) {
                this.isLoading = true;
                this.closeAllUserSessions({
                  login: error.response.data.data,
                }).then((response1) => {
                  this.isLoading = false;
                  SweetAlert.success(response1.data.message).then(() => {
                    this.AuthProvider('google');
                  });
                });
              }
            });
          } else {
            let message = error.response
              ? error.response.data.message
              : i18n.t('vie.Pag.Aut.Login.communicationWithServerError');
            if (
              error.response ||
              (error.response.data.code && error.response.data.code === 474)
            ) {
              SweetAlert.warning(message);
            } else {
              SweetAlert.danger(message);
            }
          }

          this.isLoading = false;
        });
    },

    // este metodo se encarga de mostrar un alert para solicitar cambio de contraseña
    showSwalPasswordRequest() {
      SweetAlert.input(
        i18n.t('vie.Pag.Aut.Login.resetPassword'),
        i18n.t('vie.Pag.Aut.Login.resetPasswordText1'),
        i18n.t('vie.Pag.Aut.Login.sendLink'),
        {
          type: 'text',
          placeholder: i18n.t('vie.Pag.Aut.Login.emailOrUser'),
        }
      )
        .then(
          function (result) {
            // si el usario ingresa su email, llamamos a otra funcion con ese valor
            if (result.value) {
              this.passRequestEmail({ login: result.value });
            }
          }.bind(this)
        )
        .catch((error) => {
          SweetAlert.danger(error.response.data.message);
          this.isLoading = false;
        });
    },

    // llamamos a nuestra accion pasandole por parametro el email del usuario
    passRequestEmail(user) {
      this.passwordRequest(user)
        .then((response) => {
          // si el usuario tiene contraseña temporal lo llevamos al cambio de contraseña
          if (user.password_temporary) {
            SweetAlert.default(
              i18n.t('vie.Pag.Aut.Login.changePassword'),
              `<p> ${i18n.t('vie.Pag.Aut.Login.changePasswordText1')} </p>`,
              i18n.t('common_words.continue')
            ).then((result) => {
              // si el usuario acepta llamamos a la ruta de cambio con el token
              if (result.value) {
                this.$router.push(
                  '/password_reset/' + response.data.data.token
                );
              }
            });
          } else {
            // en caso de que no sea contraseña temporal
            switch (response.data.code) {
              case 1:
                SweetAlert.success(response.data.message);
                break;
              case 2:
                SweetAlert.warning(response.data.message);
                break;
              default:
                SweetAlert.success(response.data.message);
                break;
            }
          }

          this.isLoading = false;
        })
        .catch((e) => {
          const msg = e.response.data.message;
          if (error.response.data.code && error.response.data.code === 474) {
            SweetAlert.warning(msg);
          } else {
            SweetAlert.danger(msg);
          }
          this.isLoading = false;
        });
    },

    // este metodo permite mostrar/ocultar la contraseña en el formulario
    showPassword() {
      if (this.inputTypePass === 'password') {
        this.iconBtnPass = 'fa fa-eye-slash';
        this.inputTypePass = 'text';
      } else {
        this.iconBtnPass = 'fa fa-eye';
        this.inputTypePass = 'password';
      }
    },

    toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },

    closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },

    validate() {
      this.$validator
        .validateAll()
        .then((isValid) => {
          this.enabledBtn = !isValid;
        })
        .catch((e) => {
          this.enabledBtn = false;
          this.isLoading = false;
        });
    },

    validateSubmit() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) this.signin();
      });
    },

    setRememberMe(params) {
      if (!params) {
        var date = new Date();
        date.setDate(date.getDate() + 365);
        this.$cookie.set('remember_me', true, { expires: date });
      } else this.$cookie.delete('remember_me');
    },

    startSlider() {
      if (this.sliderImages.length <= 1) return;

      this.stopSlider();
      this.sliderInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },

    stopSlider() {
      if (this.sliderInterval) {
        clearInterval(this.sliderInterval);
        this.sliderInterval = null;
      }
    },

    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.sliderImages.length;
    },

    goToSlide(index) {
      this.currentSlide = index;
      this.startSlider();
    },
  },

  /**
   * llamamos al mounted y realizamos una peticion axios al back
   * para cargar las politicas y tomar sola la ultima politica (la mas actual)
   */
  beforeCreate() {
    axios
      .get('policyversions/index')
      .then((response) => {
        if (response.data.data) {
          this.policy = response.data.data[0];
        }
      })
      .catch((error) => {
        SweetAlert.warning(error.response.data.message);
      });
  },

  mounted() {
    const rememberMe = this.$cookie.get('remember_me');
    if (Boolean(rememberMe)) {
      this.model.remember_me = true;
    } else {
      this.model.remember_me = false;
    }
    this.startSlider();
  },

  beforeDestroy() {
    this.stopSlider();
    this.closeMenu();
  },
};
</script>
<style>
.login-page {
  background: #ebedf1;
}

.login-split-layout {
  display: flex;
  min-height: 100vh;
}

.login-left-panel {
  width: 40%;
  background: #006535;
  color: #ffffff;
}

.login-right-panel {
  width: 60%;
  background: #ebedf1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 28px 36px 24px;
}

.login-left-content {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0px 24px;
}

.login-logo-wrapper {
  width: 100%;
  text-align: center;
}

.login-page .card {
  padding-top: 1px;
  padding-bottom: 1px;
}

.login-page .card-login {
  width: 350px;
  max-width: 90vw;
}

.login-brand-logo {
  max-width: clamp(330px, 29vw, 460px);
  width: 100%;
}

.login-field-label {
  color: #5c5c5c;
}

.login-footer-url {
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  transition: color 0.3s ease;
}

.login-footer-url:hover {
  color: #74b84b;
}

.login-footer-url:active,
.login-footer-url:focus {
  color: #ffffff;
}

.login-right-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.social-icon-link {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #006535;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: transform 0.2s ease, background 0.2s ease;
}

.social-icon-link:hover {
  color: #ffffff;
  background: #74b84b;
  transform: translateY(-2px);
}

.social-icon-link:active,
.social-icon-link:focus {
  color: #ffffff;
}

.login-slider-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

.login-slider-frame {
  width: 80%;
  max-width: 720px;
  min-height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-slider-image {
  width: 100%;
  max-height: 420px;
  object-fit: contain;
}

.login-slider-placeholder {
  width: 100%;
  min-height: 380px;
  border: 2px dashed #b8c4b6;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.9);
  color: #4a5b47;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  font-size: 20px;
}

.login-slider-dots {
  display: flex;
  gap: 10px;
  margin-top: 22px;
}

.login-slider-dot {
  width: 12px;
  height: 12px;
  border: 0;
  border-radius: 50%;
  background: #bfd0bc;
  padding: 0;
  cursor: pointer;
}

.login-slider-dot.active {
  background: #006535;
}

.login-right-footer {
  text-align: right;
  color: #9c9c9c;
  font-size: 14px;
}

.slider-fade-enter-active,
.slider-fade-leave-active {
  transition: opacity 0.65s ease, transform 0.65s ease;
}

.slider-fade-enter,
.slider-fade-leave-to {
  opacity: 0;
  transform: translateY(12px) scale(0.985);
}

.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.translate-login {
  position: absolute;
  top: 40px;
  right: 15px;
}

@media (max-width: 991px) {
  .login-split-layout {
    flex-direction: column;
  }

  .login-left-panel,
  .login-right-panel {
    width: 100%;
  }

  .login-left-content,
  .login-right-panel {
    min-height: auto;
  }

  .login-left-content {
    gap: 5px;
  }

  .login-right-panel {
    padding: 24px 20px 28px;
    gap: 32px;
  }

  .login-right-header,
  .login-right-footer {
    justify-content: center;
    text-align: center;
  }

  .login-footer-url {
    font-size: 22px;
  }

  .login-right-footer {
    font-size: 10px;
  }

  .login-slider-frame,
  .login-slider-placeholder {
    min-height: 240px;
  }
}
</style>
